export function Buttons(props){
    return(
        <button>{props.name}</button>
    )
}